import script from "./UserRenameTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRenameTransfer.vue?vue&type=script&setup=true&lang=js"

import "./UserRenameTransfer.vue?vue&type=style&index=0&id=2359bc18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2359bc18"]])

export default __exports__